import { render, staticRenderFns } from "./SyncFailure.vue?vue&type=template&id=ee18a92c&scoped=true&"
import script from "./SyncFailure.vue?vue&type=script&lang=ts&"
export * from "./SyncFailure.vue?vue&type=script&lang=ts&"
import style0 from "./SyncFailure.vue?vue&type=style&index=0&id=ee18a92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee18a92c",
  null
  
)

export default component.exports